import { UpsertPersonnelQuestionnaireDtoTypeOfIdEnum } from '@ansvar-sakerhet/api-client';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const typeOfIdEnum = z.enum([
  UpsertPersonnelQuestionnaireDtoTypeOfIdEnum.Passport,
  UpsertPersonnelQuestionnaireDtoTypeOfIdEnum.NationalId,
  UpsertPersonnelQuestionnaireDtoTypeOfIdEnum.DriverLicense,
  UpsertPersonnelQuestionnaireDtoTypeOfIdEnum.Skvid,
  UpsertPersonnelQuestionnaireDtoTypeOfIdEnum.DigitalId,
]);

export const editPersonnelDataSchema = z.object({
  firstName: z.string().min(1, 'Förnamn krävs'),
  lastName: z.string().min(1, 'Efternamn krävs'),
  arrivedAt: z.string().optional(),
  id06Comment: z.string().optional(),
  files: z
    .array(
      z.object({
        personnelFileId: z.string(),
        comment: z.string().optional(),
      })
    )
    .default([]),
  deletedFiles: z.array(z.string()).default([]),
  newFileComments: z.record(z.string()).optional(),
});

export const editQuestionnaireSchema = z.object({
  hasIdCard: z.enum(['Yes', 'No', 'Unclear']).optional(),
  hasSafetyEquipment: z.enum(['Yes', 'No']).optional(),
  canShowValidA1Certificate: z
    .enum(['Yes', 'No', 'Unclear', 'NotRequired'])
    .optional(),
  canShowValidWorkPermit: z
    .enum(['Yes', 'No', 'Unclear', 'NotRequired'])
    .optional(),
  hasSignsOfIntoxication: z.enum(['Yes', 'No', 'Unclear']).optional(),
  questionnaireComment: z.string().optional(),
  typeOfId: typeOfIdEnum.optional(),
});

export const editPersonnelSchema = editPersonnelDataSchema.merge(
  editQuestionnaireSchema
);

export type EditPersonnelFormValues = z.infer<typeof editPersonnelSchema>;

export const useEditPersonnelForm = (
  section: 'personnel' | 'questionnaire' = 'questionnaire'
) => {
  const schema =
    section === 'personnel' ? editPersonnelDataSchema : editQuestionnaireSchema;

  const methods = useForm<EditPersonnelFormValues>({
    mode: 'onTouched',
    resolver: zodResolver(schema),
    defaultValues: {
      files: [],
      deletedFiles: [],
      newFileComments: {},
    },
  });

  return methods;
};
